// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2l_uh","container":"styles_container__2V5ry","title":"styles_title__ZS5pk","wrapper":"styles_wrapper__3fVR_","answer":"styles_answer__ujeGC"};